<script setup lang="ts">
import { useTranslate } from '../../../i18n/useTranslation'
import { ConfigCategory } from '../type/ConfigCategory'

export interface ClvrConfigCategoryProps {
    category: ConfigCategory
    context: string
}

const props = withDefaults(defineProps<ClvrConfigCategoryProps>(), {})

const $t = useTranslate()
</script>

<template>
    <div class="clvr-config-category">
        <h1 class="clvr-config-category__title">{{ $t(context + ':' + category.label) }}</h1>
        <slot> </slot>
    </div>
</template>

<style lang="scss" src="./ClvrConfigCategory.scss" />
